import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import ActionButton from "../components/ActionButton";
import { useLocation } from "react-router";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
import { Link } from "react-router-dom";
import { isNotWhiteSpaceOrEmpty } from "../helper/StringExtentions";
import { RemovePlusFromString } from "../helper/RemovePlusFromString";
import Lightbox from "react-18-image-lightbox";
import { convertYouTubeURL, getThumbnailUrlFromEmbedLink } from "../helper/getThumbnailUrlFromEmbedLink";
import { whiteCard } from "../common/cssclasses";

export default function SingleSupplier() {
    const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const { currentLanguage } = useSelector(
        (state) => state.studBookSlice
    );
    const [post, setPost] = useState([]);
    const { translate } = useTranslate();
    const [images, setImages] = useState([]);
    const [imageslightbox, setImageslightbox] = useState([]);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const id = searchParams.has("id")
        ? searchParams.get("id")
        : '';

    const [showContactDetails, setShowContactDetails] = useState(false);


    function getCurrentLanguageUmbraco() {
        // Replace this with your logic to retrieve the current language
        // For example, you can retrieve it from localStorage or from a state variable
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (lang == "en") return 'en-US';
        else return 'ar-AE'; // Defaulting to English for demonstration
    }


    useEffect(() => {
        async function getdata() {
            const umbraco = await axios.get(`/umbraco/delivery/api/v1/content/item?id=${id}`, {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(),

                }
            })
            // console.log('Umbraco Suppliers asd are umbraco is', umbraco.data);
            const formattedData = umbraco.data?.map((item) => ({
                itemID: item?.id ?? '',
                itemCover: item.properties?.itemCover ? item.properties?.itemCover[0]?.url : '',
                itemImage: item.properties?.itemImage ? item.properties?.itemImage[0]?.url : '',
                itemGallery: item.properties?.itemGallery ? item.properties?.itemGallery : [],
                itemShortDescription: item?.properties?.itemShortDescription ?? '',
                itemTitle: item?.properties?.itemTitle ?? "",
                itemWebsite: item?.properties?.itemWebsite ?? "",
                itemPhone: item?.properties?.itemPhone ?? "",
                itemPdfText: item?.properties?.itemPdfText ?? "",
                itemPdfUrl: item?.properties?.itemPdf ?? "",
                itemEmail: item?.properties?.itemEmail ?? "",
                itemDescription: item?.properties?.itemDescription?.markup ?? "",
                itemDescription2: item?.properties?.itemDescription2?.markup ?? "",
                itemDescription3: item?.properties?.itemDescription3?.markup ?? "",
            }));;
            setShowContactDetails(isNotWhiteSpaceOrEmpty(formattedData[0]?.itemEmail ?? '') || isNotWhiteSpaceOrEmpty(formattedData[0]?.itemPhone ?? '') || isNotWhiteSpaceOrEmpty(formattedData[0]?.itemWebsite ?? ''))

            setPost(formattedData);
            if (formattedData.length > 0) {
                const images = formattedData[0]?.itemGallery?.map((image, index) => ({
                    src: MediaBaseURL + image.url,
                    width: 320,
                    isvideo: false,
                    height: 174,
                    caption: image.name,
                }));
                setImages(reformatImages(images, false));
                setImageslightbox(reformatImages(images, true));
            }

        }
        getdata();

    }, [currentLanguage])
    const [index, setIndex] = useState(-1);

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    function getVideoFrame(index) {
        return (<iframe width="90%" height="90%" src={imageslightbox[index].src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>);
    }

    function reformatImages(images, isLightBox) {
        if (isLightBox !== true) {
            return (
                images.map((image, index) => ({
                    src: image.isvideo ? convertYouTubeURL(getThumbnailUrlFromEmbedLink(image.src)) : getThumbnailUrlFromEmbedLink(image.src),
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className=" fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        } else {
            return (
                images.map((image, index) => ({
                    src: convertYouTubeURL(image.src),
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className=" fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        }
    }
    return (
        <>
            {post.length === 0 &&
                <Loader />
            }
            {post.length > 0 &&
                post.map((post) => (
                    <>
                        <div className='row rtl'>
                            <div className='col-lg-12 col-md-12 col-sm-12  '>
                                <div className={whiteCard}>
                                    <h2 className='fw-bold mb-3'>
                                        {post.itemTitle}
                                    </h2>
                                    <div className="mainSpacer my-4" />
                                    <img className='w-100 border-15 ' src={`${MediaBaseURL}${post.itemImage}`} alt={post.itemTitle} />
                                    {!!(post.itemDescription) && post.itemDescription != '' &&
                                        <>
                                            <div className="mainSpacer my-4" />
                                            <div dangerouslySetInnerHTML={{ __html: post.itemDescription }} className='' />
                                        </>
                                    }
                                    {!!(post.itemDescription2) && post.itemDescription2 != '' &&
                                        <>
                                            <div className="mainSpacer my-4" />
                                            <div dangerouslySetInnerHTML={{ __html: post.itemDescription2 }} className='' />
                                        </>
                                    }
                                    {!!(post.itemDescription3) && post.itemDescription3 != '' &&
                                        <>
                                            <div className="mainSpacer my-4" />
                                            <div dangerouslySetInnerHTML={{ __html: post.itemDescription3 }} className='' />
                                        </>
                                    }
                                    {showContactDetails &&
                                        (
                                            <>
                                                <div className="mainSpacer my-4" />
                                                <div className='row mb-2' >
                                                    <div className="col-sm-10 col-8">
                                                        <h2>
                                                            {translate('web.contactdetails', 'Contact Details')}
                                                        </h2>
                                                        {!!(post.itemPhone) && post.itemPhone != '' &&

                                                            <Link to={`tel:${post.itemPhone}`} target='_blank' className='Suplliericon' >
                                                                <i className=" fa-solid fa-phone C89C66"></i>
                                                                <span>{RemovePlusFromString(post.itemPhone)}</span>
                                                            </Link>
                                                        }
                                                        {!!(post.itemEmail) && post.itemEmail != '' &&

                                                            <Link to={`mailto:${post.itemEmail}`} target='_blank' className='Suplliericon'>
                                                                <i className=" fa-regular fa-envelope C89C66 "></i>
                                                                <span>{post.itemEmail}</span>
                                                            </Link>
                                                        }
                                                        {!!(post.itemWebsite) && post.itemWebsite != '' &&
                                                            <Link to={`https://${post?.itemWebsite?.trim()}`} target='_blank' className='Suplliericon'>
                                                                <i className=" fa-solid fa-globe C89C66"></i>
                                                                <span>{post.itemWebsite}</span>
                                                            </Link>
                                                        }
                                                    </div>
                                                    <div className="col-sm-2 col-4">
                                                        <img className="w-100 border-15" src={`${MediaBaseURL}${post.itemCover}`} alt={post.itemTitle} />
                                                    </div>
                                                </div>
                                            </>
                                        )

                                    }
                                    {post.itemGallery.length > 0 &&
                                        <>
                                            <div className="mainSpacer my-4" />
                                            <div className='row'>
                                                {post.itemGallery.map((item, index) => (
                                                    <div className="col-md-4 col-sm-6 col-12 mb-main">
                                                        <div className="w-100 border-15 position-relative" onClick={() => handleClick(index)} style={{ overflow: 'hidden', maxHeight: 250, cursor: 'pointer' }} >
                                                            <img className="top-0 bottom-0 left-0 right-0 w-100" src={`${MediaBaseURL}${item.url}`} alt={post.itemTitle} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    }
                                </div>


                            </div>
                        </div>
                        <>
                            {!!currentImage && (
                                /* @ts-ignore */
                                <Lightbox
                                    mainSrc={imageslightbox[index].src}
                                    nextSrc={imageslightbox[(index + 1) % imageslightbox.length].src}
                                    prevSrc={imageslightbox[(index + imageslightbox.length - 1) % imageslightbox.length].src}
                                    onCloseRequest={handleClose}
                                    onMovePrevRequest={() =>
                                        setIndex((index + imageslightbox.length - 1) % imageslightbox.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setIndex((index + 1) % imageslightbox.length)
                                    }
                                    wrapperClassName='ltr'
                                    imageLoadErrorMessage={getVideoFrame(index)}
                                />
                            )}
                        </>
                    </>
                ))
            }
        </>
    )
}
